// removed by extract-text-webpack-plugin
module.exports = {"react-datepicker__month--selecting-range":"_3oTyzE9ziMgf70-oWkrHmL"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/CreateEvent/Create/datepicker.css
// module id = 410
// module chunks = 37